import React, { useEffect, useState } from "react";
import axios from "../../../Uri";
import BuildingsLayout from "./buildingsLayout/buildingsLayout";
import BedSummaryChart from "./buildingspieCharts/bedSummaryChart";
import SummaryTable from "./buildingsSummaryTable/SummaryTable";
import { Grid, Select, MenuItem } from "@mui/material";
import EmailBtn from "./EmailBtn/EmailBtn";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useStyles from "./Style";
import MDBox from "components/MDBox";
import FinancialStatus from "./financialStatus/FinancialStatus";
import OccupancyFilters from "./occupancyFilters/OccupancyFilters";
import ColorFilters from "./colorFilters/ColorFilters";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import {
  getBedsByBuildingId,
  getBedsByColorFilter,
} from "../../../redux/actions/RatActions";
import TodayIncome from "./TodayIncome";
function AdmBuildingDropdown(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [selected, setSelected] = React.useState("");
  const [building, setBuilding] = React.useState([]);
  const [buildingId, setbuildingId] = React.useState();
  const [year, setYear] = useState();
  const [types,setTypes]=useState()
  const getYear = (id) => {
    setYear(id);
  };
  const getType =(type)=>{
    setTypes(type)
  }
  useEffect(() => {
    axios.get("bed/getAllBuildings").then((res) => {
      setBuilding(res.data);
    });
  }, []);
  return (
    <>
      <Grid container spacing={1}>
        <Grid item lg={6} md={6} xs={12}>
          <label value="Select Building: ">Select Building: </label>
          <Select
            sx={{ minHeight: 44 }}
            style={{ width: "50%", height: "10%" }}
            value={selected}
            name="building"
            IconComponent={() => <ArrowDropDownIcon className={classes.size} />}
          >
            {building.map((post) => {
              return (
                <MenuItem
                  value={post.buildingName}
                  onClick={async () => {
                    setSelected(post.buildingName);
                    setbuildingId(post.buildingId);
                    dispatch(getBedsByBuildingId(post.buildingId));
                  }}
                >
                  {" "}
                  {post.buildingName}{" "}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        <Grid item xs={6}>
          {buildingId == null ? (
            <div></div>
          ) : (
            <EmailBtn buildingId={buildingId} />
          )}
        </Grid>
      </Grid>
      {buildingId == null ? (
        <div></div>
      ) : (
        <div>
          {" "}
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} xs={12}>
              <BedSummaryChart buildingId={buildingId} />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <SummaryTable buildingId={buildingId} />
            </Grid>
          </Grid>
          <MDBox padding="30px">
            <FinancialStatus buildingId={buildingId} />
            <br />
            <br />
            <ColorFilters buildingId={buildingId} year={year} getType={getType}/>
          </MDBox>
          <BuildingsLayout buildingId={buildingId} />
        </div>
      )}
      <ToastContainer
        position="top-right"
        min-width="2%"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
export default AdmBuildingDropdown;
